import {Locales} from '@netx/core-next/locales/utils/Locales';

export const CartAssetActionLabel = Locales((i18n) => ({
	ADD_TO_CART: i18n('i18n.addToCart'),
	REMOVE_FROM_CART: i18n('i18n.removeFromCart'),
	TOGGLE_IN_CART: i18n('i18n.toggleInCart'),
}));
